export interface NewPermissions {
   orderCreate: string;
   orderRead: string;
   orderUpdate: string;
   orderDelete: string;
   menuCreate: string;
   menuRead: string;
   menuUpdate: string;
   menuDelete: string;
}

export enum Role {
    OWNER = 'owner',
    ADMIN = 'admin',
    WAITER = 'waiter',
}

export interface Access {
    role: Role;
    email: string;
    isActive: boolean;
    createdAt: string;
}

